import React from 'react';
import { CHAT_DISCLAIMER_LINES, WELCOME_MESSAGE } from '../constants';

export default function ChatWelcome() {
  return (
    <div className="chatbox-welcome">
      <div className="chatbox-welcome-orb" aria-hidden="true" />
      <p className="chatbox-welcome-kicker">Mirë se vini</p>
      <h4 className="chatbox-welcome-title">Si mund t&apos;ju ndihmoj?</h4>
      <p className="chatbox-welcome-text">{WELCOME_MESSAGE}</p>
      <p className="chatbox-welcome-note" role="note">
        {CHAT_DISCLAIMER_LINES.join(' ')}
      </p>
    </div>
  );
}
